import { render } from "./ItemChuyenDi.vue?vue&type=template&id=5f4b8561&scoped=true"
import script from "./ItemChuyenDi.vue?vue&type=script&lang=js"
export * from "./ItemChuyenDi.vue?vue&type=script&lang=js"

import "./ItemChuyenDi.vue?vue&type=style&index=0&id=5f4b8561&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f4b8561"]])

export default __exports__